import 'css-chunksrc/client/scenes/addIdentityProvider/form/styles.scss';export default {
  "header": "_header_kebpf_1",
  "main": "_main_kebpf_9",
  "name": "_name_kebpf_13",
  "iconBox": "_iconBox_kebpf_19",
  "icon": "_icon_kebpf_19",
  "open": "_open_kebpf_34"
};